module.exports = __webpack_public_path__ + "static/media/33000148.bff3a67e.jpg";